function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useState } from 'react';
import { Button } from '@edusense/shared-ui-kit';
import { AuthorDisplay } from '@edusense/shared-ui';
/**
 * 사용자 항목 컴포넌트
 * 팔로우 추천, 팔로워, 팔로잉 목록 등 다양한 컨텍스트에서 사용 가능
 */ var UserItem = function(param) {
    var id = param.id, name = param.name, username = param.username, profileImage = param.profileImage, tmp = param.isFollowing, initialFollowingState = tmp === void 0 ? false : tmp, onFollowClick = param.onFollowClick, onClick = param.onClick, description = param.description, _param_showFollowButton = param.showFollowButton, showFollowButton = _param_showFollowButton === void 0 ? true : _param_showFollowButton, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    // 내부 상태로 팔로우 상태 관리
    var _useState = _sliced_to_array(useState(initialFollowingState), 2), isFollowing = _useState[0], setIsFollowing = _useState[1];
    var handleFollowClick = function(e) {
        e.stopPropagation(); // 아이템 클릭 이벤트 방지
        // 상태 토글
        var newFollowingState = !isFollowing;
        setIsFollowing(newFollowingState);
        if (onFollowClick) {
            onFollowClick(id, newFollowingState);
        }
    };
    var handleClick = function() {
        if (onClick) {
            onClick(id);
        }
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition cursor-pointer ".concat(className),
        onClick: handleClick
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-between items-center"
    }, /*#__PURE__*/ React.createElement(AuthorDisplay, {
        author: {
            id: id,
            name: name,
            username: username,
            profileImage: profileImage
        },
        size: "md",
        showTimestamp: false,
        layout: "stacked",
        className: "flex-1"
    }, description && /*#__PURE__*/ React.createElement("p", {
        className: "text-xs text-gray-500 dark:text-gray-400 mt-0.5"
    }, description)), showFollowButton && /*#__PURE__*/ React.createElement(Button, {
        variant: isFollowing ? 'outline' : 'secondary',
        size: "sm",
        shape: "circular",
        onClick: handleFollowClick,
        className: isFollowing ? 'hover:text-red-500 hover:border-red-500 hover:bg-red-50 dark:hover:bg-red-900/20' : ''
    }, isFollowing ? '팔로잉' : '팔로우')));
};
export default UserItem;
